'use strict'

import model from '@/model'
import file from '@/libs/file'
import storage from '@/libs/storage'
import blocklyUtil from '@/blockly/blocklyUtil'

const list = async (_this) => {
  log('userHandler.list()')
  const userInfo = _this.$store.state.userInfo
  return await model.user.list(userInfo.uid)
}

const open = async (_this, project) => {
  log('userHandler.open()')
  const userInfo = _this.$store.state.userInfo
  const setProject = _this.$store._mutations.setProject[0]
  const setBlocklyXml = _this.$store._mutations.setBlocklyXml[0]
  const xml = await file.getUser(userInfo.uid, project)
  setBlocklyXml(xml)
  blocklyUtil.setWorkspaceXml(xml)
  project.type = 'user'
  await model.current.set(userInfo.uid, project)
  setProject(project)
}

const save = async (_this, saveProject, originProject) => {
  log('userHandler.save()')
  const userInfo = _this.$store.state.userInfo
  const setConfirmPopupData = _this.$store._mutations.setConfirmPopupData[0]
  const setBlocklyXml = _this.$store._mutations.setBlocklyXml[0]
  const setIsModified = _this.$store._mutations.setIsModified[0]
  let xml
  // if rename, then skip saving file
  if (_.get(saveProject, 'fileName') !== _.get(originProject, 'fileName')) {
    if (originProject && originProject.fileName) {
      xml = await file.getSampleOrUser(originProject, userInfo.uid)
    } else {
      blocklyUtil.removeDisabledBlock()
      xml = blocklyUtil.getWorkspaceXml()
    }
    await file.setUser(userInfo.uid, saveProject, xml)
    setBlocklyXml(xml)
    setIsModified(false)
    storage.local.setItem('isModified', false)
  }
  await model.user.set(userInfo.uid, saveProject.fileName, {
    fileName: saveProject.fileName,
    projectName: saveProject.projectName,
    type: 'user'
  })
  setConfirmPopupData({
    isShow: false
  })
}

const remove = async (_this, project, removeFile = true) => {
  log('userHandler.remove()')
  const userInfo = _this.$store.state.userInfo
  await model.user.remove(userInfo.uid, project.fileName)
  if (removeFile) await file.deleteUser(userInfo.uid, project)
}

const removeAll = async (userInfo) => {
  log('userHandler.removeAll()')
  const projects = await model.user.list(userInfo.uid)
  for (let project of projects) {
    await model.user.remove(userInfo.uid, project.fileName)
    await file.deleteUser(userInfo.uid, project)
  }
  await model.user.removeAll(userInfo.uid)
}

export default {
  list,
  open,
  save,
  remove,
  removeAll
}
